export default __webpack_public_path__ + "static/assets/35a023a211c9e123ef8876e929a19229.gif";